var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { Icon } from '@iconify/react';
import { uuidv4 } from '../../../common/utils';
var SideBarItems = function (_a) {
    var sideBarItems = _a.sideBarItems, setIsClickedSideBarIcon = _a.setIsClickedSideBarIcon;
    return (_jsx(_Fragment, { children: sideBarItems.map(function (_a) {
            var tagId = _a.tagId, title = _a.title, itemTextColor = _a.itemTextColor, itemTextAlign = _a.itemTextAlign, itemBackgroundColor = _a.itemBackgroundColor, itemHoverdBackgroundColor = _a.itemHoverdBackgroundColor, itemLogoName = _a.itemLogoName;
            return (_jsx(ItemContainer, __assign({ itemTextColor: itemTextColor, itemBackgroundColor: itemBackgroundColor, itemHoverdBackgroundColor: itemHoverdBackgroundColor, onClick: function () {
                    var _a;
                    setIsClickedSideBarIcon(false);
                    (_a = document.getElementById(tagId)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
                } }, { children: _jsxs(Item, __assign({ itemTextAlign: itemTextAlign }, { children: [_jsx(IconContainer, { children: _jsx(Icon, { icon: itemLogoName !== null && itemLogoName !== void 0 ? itemLogoName : '' }) }), title] })) }), uuidv4()));
        }) }));
};
export default SideBarItems;
var ItemContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  color: ", ";\n  background-color: ", ";\n  padding: 0.2em 1em;\n  margin: 1px;\n  text-decoration: none;\n  border-radius: 4px;\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  color: ", ";\n  background-color: ", ";\n  padding: 0.2em 1em;\n  margin: 1px;\n  text-decoration: none;\n  border-radius: 4px;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var itemTextColor = _a.itemTextColor;
    return itemTextColor;
}, function (_a) {
    var itemBackgroundColor = _a.itemBackgroundColor;
    return itemBackgroundColor;
}, function (_a) {
    var itemHoverdBackgroundColor = _a.itemHoverdBackgroundColor;
    return itemHoverdBackgroundColor;
});
var Item = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  margin: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  margin: ", ";\n"])), function (_a) {
    var itemTextAlign = _a.itemTextAlign;
    return itemTextAlign;
}, function (_a) {
    var margin = _a.margin;
    return margin !== null && margin !== void 0 ? margin : '10px 0px';
});
var IconContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
